import classNames from 'classnames';
import React, { useRef } from 'react';

import { useOnClickOutside } from '@hooks';
import Icon from '../Icon';

export interface MprPlanesSelectorProps {
	isActive?: boolean;
	onClickOutside: () => void;
	onSelection: React.MouseEventHandler<HTMLDivElement>;
}

export const MprPlanesButtons = [
	{ name: 'Axial', icon: 'tool-mpr-axial', shortcutKey: 'Shift+A', orientation: 'axial' },
	{ name: 'Coronal', icon: 'tool-mpr-coronal', shortcutKey: 'Shift+C', orientation: 'coronal' },
	{ name: 'Sagittal', icon: 'tool-mpr-sagittal', shortcutKey: 'Shift+S', orientation: 'sagittal' },
	{ name: 'Oblique MPR', icon: 'tool-mpr-oblique', shortcutKey: 'Shift+Q', orientation: 'oblique' },
];

const MprPlanesSelector = ({ isActive, onClickOutside, onSelection }: MprPlanesSelectorProps) => {
	const ref = useRef(null);
	useOnClickOutside(ref, onClickOutside);
	return (
		<div ref={ref} className="z-10 flex flex-col rounded-md border border-common-dark bg-secondary-dark pb-1 pt-1">
			{MprPlanesButtons.map((item, index) => (
				<div
					key={item.name}
					className={classNames(
						'flex h-7 w-full flex-row items-center px-2 text-sm',
						'whitespace-pre bg-primary-dark text-sm font-normal select-none',
						isActive && 'bg-primary-light',
						isActive ? 'text-primary-light' : 'text-common-light hover:bg-primary-light',
					)}
					onClick={onSelection}
					data-orientation={item.orientation.toLowerCase()}
					role="button"
					tabIndex={index}
				>
					<span className="mr-4 flex-initial">
						<Icon name={item.icon} className="h-6 w-6 text-common-light" />
					</span>

					<span className="w-full flex-1">{item.name}</span>
					<span className="ml-5">{`(${item.shortcutKey})`}</span>
				</div>
			))}
		</div>
	);
};

export default MprPlanesSelector;
